var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bg-light-grey h-100",attrs:{"fluid":""}},[_c('div',{staticClass:"vertical-center text-center"},[_c('h4',[_vm._v(_vm._s(_vm.loadingText))]),_c('p',{attrs:{"id":"video"}},[_c('Animation',{ref:"animation"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }